import React from 'react';
import { Link } from 'react-router-dom';
import { FiXCircle, FiArrowLeft } from 'react-icons/fi';

const CancelPage = () => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      flexDirection: 'column', 
      backgroundColor: '#f9fafb',
      padding: '20px'
    }}>
      <FiXCircle size={80} color="#ef4444" />
      <h1 style={{ fontSize: '2.5rem', margin: '20px 0', textAlign: 'center' }}>Payment Cancelled</h1>
      <p style={{ fontSize: '1.2rem', color: '#6b7280', marginBottom: '30px', textAlign: 'center', maxWidth: '500px' }}>
        Your subscription payment was cancelled. You can try again anytime or continue using the free plan.
      </p>
      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <Link 
          to="/" 
          style={{ 
            padding: '12px 24px', 
            backgroundColor: '#FF9900', 
            color: 'white', 
            textDecoration: 'none', 
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontWeight: '600'
          }}
        >
          <FiArrowLeft size={16} />
          Back to Home
        </Link>
        <Link 
          to="/dashboard" 
          style={{ 
            padding: '12px 24px', 
            backgroundColor: '#6b7280', 
            color: 'white', 
            textDecoration: 'none', 
            borderRadius: '8px',
            fontWeight: '600'
          }}
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default CancelPage; 